import { httpClient } from "@api/http";

export interface OwnerSettings {
    language: string;
    currency: string;
    emailNotifications: boolean;
    pushNotifications: boolean;
    theme: "light" | "dark";
}

export interface SettingsResponse {
    message: string;
    settings: OwnerSettings;
}

const flat = <T>(request: Promise<unknown>) => request as Promise<T>;

export const settingsApi = {
    get: () => flat<SettingsResponse>(httpClient.get("/owner/settings")),

    update: (patch: Partial<OwnerSettings>) =>
        flat<SettingsResponse>(httpClient.patch("/owner/settings", patch)),
};
